var _rect, _rect2, _g, _rect3, _rect4, _path, _ellipse, _rect5, _ellipse2, _ellipse3, _ellipse4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallDocGms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 96,
    viewBox: "0 0 136 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.2751,
    y: 81.4286,
    width: 34.425,
    height: 3.85714,
    rx: 1.92857,
    fill: "#80C0FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.375,
    y: 81.4286,
    width: 20.4,
    height: 3.85714,
    rx: 1.92857,
    fill: "#80C0FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5347_993)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 30,
    width: 30,
    height: 27,
    fill: "#CD0C20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4648 29.9424H102.587L108.058 57.2878H80.4648V29.9424Z",
    fill: "#559BDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.848 29.9424L105.441 57.2878H77.848V29.9424Z",
    fill: "#C9DDEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9334 27.1743H80.5316V23.7298C80.5316 22.3721 81.0454 21.0144 82.0682 19.983C83.0959 18.9467 84.4375 18.4286 85.7838 18.4286H88.6764C90.0227 18.4286 91.3691 18.9467 92.392 19.983C93.4148 21.0192 93.9286 22.3721 93.9286 23.7298V27.1743H93.9334Z",
    fill: "#CD0C20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.171 55.3017C115.123 54.7836 115.042 54.2607 114.923 53.7426C114.723 52.8311 114.419 51.9627 114.038 51.1472L103.02 27.6253C102.597 26.7282 101.931 25.9366 101.036 25.3609C100.142 24.79 99.1475 24.5214 98.1627 24.5214H33.8227L27.4477 74.8753H40.8923C40.8923 68.1637 46.2873 62.7282 52.9382 62.7282C59.5939 62.7282 64.9841 68.1637 64.9841 74.8753H78.6047C78.6047 68.1637 83.9949 62.7282 90.6506 62.7282C97.3063 62.7282 102.697 68.1637 102.697 74.8753H115.228V56.4675C115.223 56.0837 115.204 55.6951 115.171 55.3017ZM85.1605 52.7063C84.6182 52.7063 84.0806 52.5 83.6714 52.0875C83.2575 51.6701 83.0577 51.128 83.0577 50.5859V33.2239C83.0577 32.7394 83.2385 32.25 83.6096 31.8806C83.9759 31.516 84.4564 31.3241 84.9417 31.3241H95.6888C96.4643 31.3241 97.2493 31.5448 97.9438 32.0054C98.6432 32.4611 99.1522 33.0992 99.4615 33.814L105.97 48.8684C106.322 49.6887 106.274 50.6626 105.751 51.4638C105.228 52.2698 104.362 52.7063 103.477 52.7063H85.1605Z",
    fill: "#E3EEF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9331 64.1866C47.0767 64.1866 42.3335 68.9745 42.3335 74.8801C42.3335 80.781 47.0767 85.5688 52.9331 85.5688C58.7896 85.5688 63.5328 80.781 63.5328 74.8801C63.5328 68.9697 58.7943 64.1866 52.9331 64.1866ZM52.9331 79.2074C50.5639 79.2074 48.6419 77.2693 48.6419 74.8801C48.6419 72.491 50.5639 70.5529 52.9331 70.5529C55.3023 70.5529 57.2243 72.491 57.2243 74.8801C57.2291 77.2693 55.3071 79.2074 52.9331 79.2074Z",
    fill: "#EA9D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.798 64.1866C84.9415 64.1866 80.1983 68.9745 80.1983 74.8801C80.1983 80.781 84.9415 85.5688 90.798 85.5688C96.6496 85.5688 101.398 80.781 101.398 74.8801C101.398 68.9697 96.6496 64.1866 90.798 64.1866ZM90.798 79.2074C88.4287 79.2074 86.5067 77.2693 86.5067 74.8801C86.5067 72.491 88.4287 70.5529 90.798 70.5529C93.1672 70.5529 95.0892 72.491 95.0892 74.8801C95.094 77.2693 93.1719 79.2074 90.798 79.2074Z",
    fill: "#EA9D00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7175 54.8892L27.6567 74.5394H41.1013C41.1013 67.8278 46.4963 62.3923 53.1472 62.3923C59.8029 62.3923 65.1931 67.8278 65.1931 74.5394H78.8138C78.8138 67.8278 84.204 62.3923 90.8597 62.3923C97.5154 62.3923 102.906 67.8278 102.906 74.5394H115.437V56.1316C115.432 55.7478 115.413 55.3593 115.38 54.9659C115.377 54.9403 115.375 54.9147 115.372 54.8892H29.7175Z",
    fill: "#80C0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.659 58.6408C116.659 57.1919 116.055 55.9446 115.194 55.3689V61.9126C116.055 61.3369 116.659 60.0944 116.659 58.6408Z",
    fill: "#FAD7B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.368 72.6541C117.368 73.8246 116.426 74.7745 115.265 74.7745H105.803C104.642 74.7745 103.7 73.8246 103.7 72.6541L104.566 68.1205C104.566 66.9499 105.508 66 106.669 66H116.131C117.292 66 118.234 66.9499 118.234 68.1205L117.368 72.6541Z",
    fill: "#68A0D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0433 72.654C37.0433 73.8246 36.1013 74.7745 34.9405 74.7745H25.4779C24.3171 74.7745 23.3751 73.8246 23.3751 72.654L24.0126 68.1204C24.0126 66.9498 24.9546 65.9999 26.1154 65.9999H35.578C36.7388 65.9999 37.6808 66.9498 37.6808 68.1204L37.0433 72.654Z",
    fill: "#68A0D1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 38.5,
    r: 6.5,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 35,
    width: 2,
    height: 7,
    fill: "#CD0C20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 37.5,
    width: 2,
    height: 7,
    transform: "rotate(90 51 37.5)",
    fill: "#CD0C20"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.56074,
    height: 6.40185,
    rx: 1.28037,
    transform: "matrix(0.704142 -0.710059 0.704142 0.710059 75.6499 12.5326)",
    fill: "#CD0C20"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 86.4558,
    y: 8.11047,
    width: 2.55,
    height: 6.42857,
    rx: 1.275,
    fill: "#CD0C20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.9 9.42852C113.9 12.2688 109.048 14.5714 103.063 14.5714C97.0772 14.5714 92.2251 12.2688 92.2251 9.42852C92.2251 6.5882 93.8897 6.21423 99.8751 6.21423C105.86 6.21423 113.9 6.5882 113.9 9.42852Z",
    fill: "#F9F9F9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.0503,
    cy: 7.5,
    rx: 6.37501,
    ry: 4.5,
    fill: "#F9F9F9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.56074,
    height: 6.40185,
    rx: 1.28037,
    transform: "matrix(-0.704142 -0.710059 -0.704142 0.710059 99.811 12.5326)",
    fill: "#CD0C20"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.3251,
    cy: 17.7857,
    rx: 11.475,
    ry: 5.78571,
    fill: "#F9F9F9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.3,
    cy: 10.7143,
    rx: 15.3,
    ry: 7.71429,
    fill: "#F9F9F9"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.425,
    cy: 10.7143,
    rx: 11.475,
    ry: 7.71429,
    fill: "#F9F9F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5347_993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.6251,
    height: 78.4286,
    fill: "white",
    transform: "translate(23.375 14.5714)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallDocGms);
export default __webpack_public_path__ + "static/media/call_doc_gms.b447a356c5cba3e2602826441fb43c0d.svg";
export { ForwardRef as ReactComponent };